// src/layouts/admin/AdminLayout.js
import React, { useState } from "react";
import AdminTopbar from "../../components/admin/AdminTopbar";
import AdminSidebar from "../../components/admin/AdminSidebar";

export default function AdminLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const closeSidebar = () => setSidebarOpen(false);
  const toggleSidebar = () => setSidebarOpen((v) => !v);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      {/* 상단바에 모바일용 사이드바 토글 버튼 전달 */}
      <AdminTopbar onToggleSidebar={toggleSidebar} />

      <div className="mx-auto flex max-w-7xl gap-6 px-4 py-6">
        {/* 데스크톱: 항상 보이는 사이드바 */}
        <div className="hidden md:block">
          <AdminSidebar />
        </div>

        {/* 모바일: 슬라이드 오버 사이드바 */}
        {sidebarOpen && (
          <div className="fixed inset-0 z-40 flex md:hidden">
            {/* 반투명 배경 */}
            <div className="fixed inset-0 bg-black/40" onClick={closeSidebar} />
            {/* 좌측에서 나오는 패널 */}
            <div className="relative z-50 ml-0 h-full w-72 max-w-full bg-white shadow-xl">
              <div className="flex items-center justify-between border-b px-4 py-3">
                <span className="text-sm font-semibold text-slate-800">
                  관리자 메뉴
                </span>
                <button
                  type="button"
                  onClick={closeSidebar}
                  className="rounded-md px-2 py-1 text-xs text-slate-600 hover:bg-slate-100"
                >
                  닫기
                </button>
              </div>
              <div className="p-4">
                {/* 모바일에선 메뉴 선택 시 자동으로 닫히도록 onNavigate 전달 */}
                <AdminSidebar onNavigate={closeSidebar} />
              </div>
            </div>
          </div>
        )}

        {/* 본문 */}
        <main className="w-full">{children}</main>
      </div>
    </div>
  );
}
